module.exports = __webpack_public_path__ + "media/images/sport--ski_alpin-freestyle-03beeee3aa9446c330a81f8a9527986c.png";